import ReactGA from 'react-ga4'

export const initializeGA = trackingCode =>
  ReactGA.initialize(trackingCode, {
    testMode: process.env.NODE_ENV === 'development',
    // debug: process.env.NODE_ENV === 'development',
    // titleCase: false,
  })

export const setGACustomEvent = (eventName, params) =>
  ReactGA.event(eventName, params)
export const setGACustomPageView = ({ page, title }) =>
  ReactGA.send({
    page,
    title,
    hitType: 'pageview',
  })

export const setGAUserId = userId => ReactGA.set({ userId })

export const setGAUserProperties = userProperties =>
  ReactGA.set({
    user_properties: userProperties,
  })

// depcricated after GA4 migration
// TO DO: update events using setGAPageView & setGAEvent
export const setGAPageView = page => ReactGA.send(page)
export const setGAEvent = (category, action, label, value) =>
  ReactGA.event({
    category,
    action,
    label,
    value,
  })
